import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const PriceTag = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666504 1.33317C0.666504 0.964981 0.964981 0.666504 1.33317 0.666504H7.99984C8.17665 0.666504 8.34622 0.736742 8.47124 0.861766L14.6646 7.0551C15.5516 7.94212 15.5516 9.39089 14.6646 10.2779L10.2779 14.6646C9.39089 15.5516 7.94212 15.5516 7.0551 14.6646L0.861766 8.47124C0.736742 8.34622 0.666504 8.17665 0.666504 7.99984V1.33317ZM1.99984 1.99984V7.72369L7.99791 13.7218C8.36422 14.0881 8.96878 14.0881 9.3351 13.7218L13.7218 9.3351C14.0881 8.96878 14.0881 8.36422 13.7218 7.99791L7.72369 1.99984H1.99984ZM3.99984 4.6665C3.99984 4.29831 4.29831 3.99984 4.6665 3.99984H4.67317C5.04136 3.99984 5.33984 4.29831 5.33984 4.6665C5.33984 5.03469 5.04136 5.33317 4.67317 5.33317H4.6665C4.29831 5.33317 3.99984 5.03469 3.99984 4.6665Z"
      fill="#0D375E"
    />
  </svg>
));

export default PriceTag;
